import { useQuery } from '@tanstack/react-query'
import { listSurveys } from 'api/surveys'
import { queryKeys } from 'constants/queryKeys'
import { useAuth } from 'contexts/AuthContext'
import { toErrorMessage } from './utils'

const LOAD_SURVEYS_ERROR = 'アンケート一覧の読み込みに失敗しました。'

type UseSurveysOptions = {
  enabled?: boolean
}

export function useSurveys({ enabled = true }: UseSurveysOptions = {}) {
  const { user } = useAuth()
  const canFetch = Boolean(user?.uid) && enabled

  const query = useQuery({
    queryKey: [queryKeys.SURVEYS, user?.uid],
    enabled: canFetch,
    queryFn: listSurveys,
    retry: false,
  })

  return {
    surveys: query.data ?? [],
    loading: canFetch && (query.isPending || query.isFetching),
    error: query.error
      ? toErrorMessage(query.error, LOAD_SURVEYS_ERROR)
      : undefined,
    refetch: query.refetch,
  }
}
